var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#333333",
    stroke: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4375 10.875H11.375V10.9375V16.875C11.375 17.1071 11.2828 17.3296 11.1187 17.4937C10.9546 17.6578 10.7321 17.75 10.5 17.75C10.2679 17.75 10.0454 17.6578 9.88128 17.4937C9.71719 17.3296 9.625 17.1071 9.625 16.875V10.9375V10.875H9.5625H3.625C3.39294 10.875 3.17038 10.7828 3.00628 10.6187C2.84219 10.4546 2.75 10.2321 2.75 10C2.75 9.76794 2.84219 9.54538 3.00628 9.38128C3.17038 9.21719 3.39294 9.125 3.625 9.125H9.5625H9.625V9.0625V3.125C9.625 2.89294 9.71719 2.67038 9.88128 2.50628C10.0454 2.34219 10.2679 2.25 10.5 2.25C10.7321 2.25 10.9546 2.34219 11.1187 2.50628C11.2828 2.67038 11.375 2.89294 11.375 3.125V9.0625V9.125H11.4375H17.375C17.6071 9.125 17.8296 9.21719 17.9937 9.38128C18.1578 9.54538 18.25 9.76794 18.25 10C18.25 10.2321 18.1578 10.4546 17.9937 10.6187C17.8296 10.7828 17.6071 10.875 17.375 10.875H11.4375Z",
    strokeWidth: 0.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9c4fc6396f86d6a75764a0048b280a59.svg";
export { ForwardRef as ReactComponent };